import { FC } from 'react';
import Box from '@/components/UI/box/Box';
import Divider from '@/components/UI/divider/Divider';
import Typography from '@/components/UI/typography/Typography';
import Styles from './HouseAbout.module.scss';
import ShowMorePopUp from '@/components/houses/_reusable/houseInfo/ShowMorePopUp/ShowMorePopUp';
type Props = {
  about: string;
};
const HouseAbout: FC<Props> = ({
  about
}) => {
  const words = about?.split(' ');
  const limitedWords = words?.slice(0, 25);
  const limitedText = limitedWords?.join(' ');
  return <Box className={Styles['house-about']} component={'section'} data-sentry-element="Box" data-sentry-component="HouseAbout" data-sentry-source-file="HouseAbout.tsx">
      <Box className={Styles['container']} data-sentry-element="Box" data-sentry-source-file="HouseAbout.tsx">
        <Typography variant="bodyL_Bold" color="neutral_800" component="h2" data-sentry-element="Typography" data-sentry-source-file="HouseAbout.tsx">
          درباره اقامتگاه
        </Typography>
        <Typography variant="bodyM" color="secondary_main" className={Styles['description']} data-sentry-element="Typography" data-sentry-source-file="HouseAbout.tsx">
          {Number(words?.length) > 25 ? `${limitedText}...` : limitedText}
        </Typography>
      </Box>
      {Number(words?.length) > 25 && <ShowMorePopUp title="about" maxWidth={'700px'}>
          <Typography variant="bodyL" color="neutral_800" className={Styles['about']} component="p">
            {about}
          </Typography>
        </ShowMorePopUp>}
      <Divider orientation="horizontal" data-sentry-element="Divider" data-sentry-source-file="HouseAbout.tsx" />
    </Box>;
};
export default HouseAbout;